import { Typography } from 'components/_common/Typography';
import { RiskLikelihood } from 'models/RiskCategories';
import React from 'react';

type ImportationRiskLikelihoodSummaryProps = {
  locationName: string;
  importationRiskLikelihood: RiskLikelihood;
};

const ImportationRiskLikelihoodSummary: React.FC<ImportationRiskLikelihoodSummaryProps> = ({
  locationName,
  importationRiskLikelihood,
}) => {
  switch (importationRiskLikelihood) {
    case 'Low':
    case 'Moderate':
    case 'High':
    case 'Very high': {
      return (
        <div data-testid="importation-risk-likelihood-summary">
          <Typography variant="subtitle1" inline>
            {importationRiskLikelihood} likelihood that cases will arrive
          </Typography>{' '}
          in {locationName} within the next month
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

export default ImportationRiskLikelihoodSummary;
